import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';
import { share } from 'rxjs/operators';
import { ARBleService } from './agrorendement-ble.service';
import { AROrgeService } from './agrorendement-orge.service';
import { ARColzaService } from './agrorendement-colza.service';
import { ARBleCampaign } from '../models/agrorendement-ble.model';
import { AROrgeCampaign } from '../models/agrorendement-orge.model';
import { ARColzaCampaign } from '../models/agrorendement-colza.model';
import { PlanningFilterExploitation, PlanningFilterParcel, PlanningService } from './planning.service';
import { Parcel } from '../models/parcel.model';

@Injectable({ providedIn: 'root' })
export class PlanningDataService {
  constructor(
    private planningService: PlanningService,
    private bleService: ARBleService,
    private orgeService: AROrgeService,
    private colzaService: ARColzaService,
  ) {}

  getAllCampaigns(): Observable<[ARBleCampaign[], AROrgeCampaign[], ARColzaCampaign[]]> {
    const ble$ = this.bleService.getCampaigns().pipe(share());
    const orge$ = this.orgeService.getCampaigns().pipe(share());
    const colza$ = this.colzaService.getCampaigns().pipe(share());

    return forkJoin([ble$, orge$, colza$]) as Observable<[ARBleCampaign[], AROrgeCampaign[], ARColzaCampaign[]]>;
  }

  getAllFarms(
    culture: string,
    passage: string,
    campaignFilter: number,
    filterFarm: PlanningFilterExploitation,
  ): Observable<Parcel[]> {
    return this.planningService.getFarms(culture, passage, campaignFilter, null, 'name', 'asc', filterFarm, null);
  }

  getAllParcels(
    culture: string,
    passage: string,
    campaignFilter: number,
    farmIds: number[],
    filter: PlanningFilterParcel,
    page: number,
    pageSize: number,
  ): Observable<any> {
    return this.planningService.getParcelsFarms(
      culture,
      passage,
      campaignFilter,
      farmIds,
      null,
      null,
      null,
      filter,
      null,
      page,
      pageSize,
    );
  }

  getParcelDetails(culture: string, parcelId: number): Observable<any> {
    return this.planningService.getParcel(parcelId, culture);
  }
}
